<template>
    <div class="map-wrap" :class="classObj">
        <mapbox-gl-map
        id="map"
        :accessToken="$cfg.mapboxgl.accessToken"
        :options="getMapOptions()"
        @loaded="mapLoaded"/>
        <chart-modal v-if="$store.state.showChartModal" />
        <overlap-picker
        @select="selectStation"
        v-model="showOverlapPicker"
        :features="overlapFeatures">
            <template slot="header" slot-scope="slotScope">
                {{ slotScope.numFeatures }} stations at these coordinates
            </template>
            <template slot="listItem" slot-scope="slotScope">
                <v-list-tile-title v-text="slotScope.feature.properties.name"></v-list-tile-title>
                <v-list-tile-sub-title class="text--primary">
                    {{ slotScope.feature.properties.nid }}
                </v-list-tile-sub-title>
            </template>
        </overlap-picker>
        <style-switcher v-model="showStyleSwitcher" @switchedStyle="addLayers" />
        <map-save-button v-model="showMapSave" :featuresUrl="mapSourceUrl">
            <template slot="features-headline">Download stations</template>
        </map-save-button>
        <map-legend v-model="showMapLegend" :items="getLegendLayers()" />
        <map-sidebar :filters="filters" />
    </div>
</template>

<script>
import stationsPage from '@/mixins/stationsPage';
import mapLegend from '@/mixins/mapLegend';

import ChartModal from '@/components/ChartModalSwQuality';
import MapSaveButton from '@/components/MapSaveButton';

export default {
    name: 'SurfaceWaterQuality',
    components: {
        ChartModal,
        MapSaveButton,
    },
    mixins: [
        stationsPage,
        mapLegend,
    ],
    data() {
        return {
            name: 'surface water quality',
            mapSourceUrl: `${this.$cfg.API_URL}/stations/surface-water-quality`,
            stationType: 'SURFACE_WATER_QUALITY',
            filters: [
                'network',
                'analyses',
                'yearMin',
                'yearMax',
            ],
            showMapSave: false,
        };
    },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.map-wrap {
    height: 100%;
    display: flex;
    position: relative;
}

#map-1 {
    height: 100%;
}
</style>

<style lang="scss">
@import '~@/assets/globals.scss';

.tooltip-marker {
    opacity: 1;
    transition: opacity 150ms;
    width: 120px;
    z-index: 2;
    background: rgba(28, 28, 28, .65);
    border-radius: .25rem;
    padding: .5rem .75rem;
    color: #eee;
    line-height: 1.2;

    &.hidden {
        opacity: 0;
    }
}

// strip styles from popup container
// (so we can mount v-cards on the element)
.mapboxgl-popup-content {
    background: none;
    box-shadow: none;
    padding: 0;
}

// move map control areas when the sidebar is showing
.showing-sidebar {
    .mapboxgl-ctrl-bottom-right,
    .mapboxgl-ctrl-top-right {
        right: $sidebar-width; // width of the sidebar
    }
}
</style>



// WEBPACK FOOTER //
// src/pages/SurfaceWaterQuality.vue